import { render, staticRenderFns } from "./SponsoringUnitClassComponent.vue?vue&type=template&id=398866c5&"
import script from "./SponsoringUnitClassComponent.vue?vue&type=script&lang=ts&"
export * from "./SponsoringUnitClassComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('398866c5')) {
      api.createRecord('398866c5', component.options)
    } else {
      api.reload('398866c5', component.options)
    }
    module.hot.accept("./SponsoringUnitClassComponent.vue?vue&type=template&id=398866c5&", function () {
      api.rerender('398866c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Course/SponsoringUnitClassComponent.vue"
export default component.exports